// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function LogoWhitesvgIcon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 112 47"}
      height={"1em"}
      width={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M33.429 33.69V13.696h7.037c.95 0 1.834.158 2.654.475a6.368 6.368 0 012.178 1.284 6.058 6.058 0 011.452 2.011c.354.764.53 1.61.53 2.542 0 .95-.176 1.815-.53 2.597a6.139 6.139 0 01-1.452 1.983A6.74 6.74 0 0143.12 25.9a7.706 7.706 0 01-2.654.447H37.2v7.345h-3.77zm7.093-10.919c.987 0 1.732-.279 2.234-.838a2.837 2.837 0 00.559-2.96 2.047 2.047 0 00-.559-.865 2.502 2.502 0 00-.921-.615c-.373-.149-.81-.223-1.313-.223H37.2v5.501h3.323zm9.123 10.92V13.695h3.659v19.996h-3.659zm15.09-1.452h-.224a6.08 6.08 0 01-1.564 1.34c-.596.373-1.369.559-2.318.559a5.583 5.583 0 01-2.011-.363 5.022 5.022 0 01-1.62-.95 4.31 4.31 0 01-1.089-1.48 4.56 4.56 0 01-.39-1.899c0-.708.139-1.34.418-1.9a4.33 4.33 0 011.173-1.48 5.12 5.12 0 011.76-.92 7.203 7.203 0 012.234-.336c.893 0 1.629.075 2.206.224a9.71 9.71 0 011.424.418v-.419c0-.726-.288-1.321-.866-1.787-.577-.484-1.294-.726-2.15-.726-1.266 0-2.337.53-3.212 1.592l-2.653-1.815c1.453-1.825 3.435-2.737 5.949-2.737 2.122 0 3.742.502 4.86 1.508 1.116.987 1.675 2.457 1.675 4.412v8.21h-3.603v-1.45zm0-4.106a6.746 6.746 0 00-1.341-.474 5.275 5.275 0 00-1.48-.196c-.876 0-1.555.196-2.04.587-.465.372-.697.837-.697 1.396 0 .558.223 1.005.67 1.34a2.65 2.65 0 001.592.503c.484 0 .93-.084 1.34-.251.41-.186.754-.42 1.033-.698.298-.298.522-.633.67-1.006.168-.39.252-.791.252-1.2zm9.946-6.34h.223a4.53 4.53 0 011.731-1.619c.727-.41 1.555-.614 2.486-.614.857 0 1.61.14 2.262.419a3.98 3.98 0 011.592 1.2c.428.503.745 1.118.95 1.844.223.707.335 1.498.335 2.373v8.295H80.6v-7.848c0-.986-.223-1.712-.67-2.178-.428-.484-1.061-.726-1.9-.726-.502 0-.949.112-1.34.335a3.07 3.07 0 00-.977.866c-.26.354-.466.782-.614 1.284a6 6 0 00-.196 1.564v6.703h-3.658V20.007h3.435v1.787zm13.4 1.341h-2.402v-3.127h2.402v-4.19h3.658v4.19h3.352v3.127h-3.352v5.307c0 .316.028.614.084.893.075.26.205.484.391.67.26.298.633.447 1.117.447.317 0 .568-.028.754-.083a2.89 2.89 0 00.53-.28L95.65 33.3a5.574 5.574 0 01-1.396.447 7.218 7.218 0 01-1.62.167c-.689 0-1.313-.102-1.871-.307a4.154 4.154 0 01-1.368-.893c-.876-.838-1.313-2.03-1.313-3.575v-6.005zm14.138 9.887l-5.753-13.014h4.161l3.463 8.294h.196l3.323-8.294h4.077l-8.573 19.716h-3.938l3.044-6.702z"
        }
        fill={"#fff"}
      ></path>

      <path
        opacity={".3"}
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M2.33 39.738c1.046-4.068 3.667-8.417 6.808-11.209 5.979.595 11.266-2.094 14.196-4.05-2.764 2.18-6.957 6.38-8.24 12.25-3.931 2.122-8.256 3.284-12.765 3.01z"
        }
        fill={"#88DD9B"}
      ></path>

      <path
        opacity={".6"}
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M2.33 7.175s6.848-.447 12.765 3.01c1.282 5.87 5.475 10.07 8.24 12.249-2.93-1.958-8.216-4.647-14.196-4.045-5.121-4.566-6.81-11.214-6.81-11.214z"
        }
        fill={"#88DD9B"}
      ></path>

      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M0 23.466c7.049-5.83 16.044-5.47 23.144 0-6.997 5.79-16.044 5.47-23.144 0zm17.08 23.367c-3.257-8.16-.275-17.327 7.152-22.012 3.256 8.154.28 17.326-7.153 22.012zM16.942 0C24.375 4.687 27.35 13.858 24.1 22.011 16.668 17.331 13.688 8.16 16.942 0z"
        }
        fill={"#88DD9B"}
      ></path>
    </svg>
  );
}

export default LogoWhitesvgIcon;
/* prettier-ignore-end */
